import React from "react";
import RecyclingSidebar from "../components/RecyclingSidebar";
import RecyclingNotifications from "../components/RecyclingNotifications";

const RecyclingNotificationsPage = () => {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <RecyclingSidebar />
      <RecyclingNotifications />
    </div>
  );
};

export default RecyclingNotificationsPage;
